import { render, staticRenderFns } from "./BirthDayField.vue?vue&type=template&id=2b166688&"
import script from "./BirthDayField.vue?vue&type=script&lang=js&"
export * from "./BirthDayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports